import { render, staticRenderFns } from "./IPQCQuery.vue?vue&type=template&id=4fb53422&scoped=true"
import script from "./IPQCQuery.vue?vue&type=script&lang=js"
export * from "./IPQCQuery.vue?vue&type=script&lang=js"
import style0 from "./IPQCQuery.vue?vue&type=style&index=0&id=4fb53422&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb53422",
  null
  
)

export default component.exports